export default "__VITE_ASSET__CnFoEUp8__"